import React from 'react';
import { Alert, AlertText } from '@fiverr-private/feedback';
import { appTranslate } from '../../i18n';

export const WnWInfoSection = () => (
    <Alert variant="warning" marginBottom="8">
        <AlertText>{appTranslate('wnw_flow.info')}</AlertText>
    </Alert>
);
